export default __webpack_public_path__ + "assets/images/156003ed1c7edf1ce6279c623ace1c63.png";